module.exports = __webpack_public_path__ + "static/media/logo-chats.dddbe165.svg";